import React, { memo } from 'react';
import { CTAButton } from './Shared';
export const HeroSection = () => {
  return <header className="relative overflow-hidden" data-id="element-100" data-mp="2hvccaekq532u">
      <div className="bg-grid absolute inset-0 pointer-events-none" data-id="element-101" data-mp="2hw4alx5phewt" />
      <div className="absolute inset-0 bg-gradient-to-b from-familia-bg to-familia-section opacity-50 pointer-events-none" data-id="element-102" data-mp="23w37eb1yxve6" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-6 pb-10 text-center" data-id="element-103" data-mp="28uej6rbtqfz1">
        <p className="text-familia-gold font-semibold text-[10px] sm:text-xs uppercase tracking-[0.25em] mb-2" data-id="element-104" data-mp="2wl0gpoo7chus">
          FOR FAMILIES & CAREGIVERS OF OLDER ADULTS
        </p>

        <h1 className="font-display sm:text-4xl md:text-5xl font-bold mb-4 text-[24px]" data-id="element-105" data-mp="2mup8vr1edoim">
          Give Them 15 Meaningful Minutes a Day —{' '}
          <br className="hidden md:block" data-id="element-106" data-mp="2rqw68vfq9roy" />
          <span className="text-familia-cyan" data-id="element-107" data-mp="3fi1o1g58au1w">
            Without Wondering What to Do.
          </span>
        </h1>

        <div className="relative max-w-[320px] sm:max-w-[460px] md:max-w-[560px] mx-auto mb-5" style={{
        aspectRatio: '3 / 2'
      }} data-id="element-108" data-mp="3kactszmnha2d">
          <div aria-hidden="true" className="absolute inset-0 bg-familia-cyan/20 rounded-full hidden md:block" style={{
          filter: 'blur(70px)'
        }} data-id="element-109" data-mp="2beq0qut7usr4" />
          <img src="https://cdn.magicpatterns.com/uploads/xrqH1CNqfGzGgHApmeTzKx/ChatGPT_Image_15_jun_2026__02_45_19_p.m.-removebg-preview.png" alt="Vitality 360 at-home activity and care kit for older adults" width="560" height="373" loading="eager" className="relative z-10 w-full h-full object-contain" style={{
          filter: 'drop-shadow(0 12px 24px rgba(0,0,0,0.45))'
        }} data-id="element-110" data-mp="2kdtkm107jc6o" />
        </div>

        <p className="text-familia-gray sm:text-sm max-w-xl mx-auto mb-6 text-[11px] leading-relaxed" data-id="element-111" data-mp="1dqy5w7hms3mp">
          Vitality 360™ gives you cognitive activities, gentle movement
          routines, caregiver tools and simple tracking pages — all organized in
          one practical system you can use at home.
        </p>

        <div className="flex flex-col items-center justify-center mb-6" data-id="element-112" data-mp="3duig5kysyvs0">
          <div className="bg-familia-gold text-familia-bg font-bold text-xs py-1 px-3 rounded-full uppercase mb-2" data-id="element-113" data-mp="3iqpr5s622xgt">
            Special Offer Price
          </div>
          <div className="flex items-center gap-3" data-id="element-114" data-mp="3rsp7ei98xxip">
            <span className="text-familia-red line-through text-xl" data-id="element-115" data-mp="3rrxbf6bqlxrw">
              $97 USD
            </span>
            <span className="text-familia-cyan text-4xl font-bold" data-id="element-116" data-mp="jt6g2ni0qw9">
              $27 USD
            </span>
          </div>
        </div>

        <CTAButton href="#checkout-section" className="w-full sm:w-auto text-base px-10 py-3.5 mb-4" data-id="element-117" data-mp="ac79cyqbc3k0">
          GET THE COMPLETE VITALITY 360™ KIT
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1.5 text-[10px] sm:text-xs text-familia-gray" data-id="element-118" data-mp="jbud3r6illg8">
          <span className="w-full" data-id="element-119" data-mp="23v7njst8vfyd">
            150+ Ready-to-Use Activities · Printable Resources · Caregiver Tools
            · Lifetime Access
          </span>
          <span className="flex items-center gap-1.5 font-bold" data-id="element-120" data-mp="1utgkywu03p8q">
            🛡️ Instant Digital Access · One-Time Payment · Lifetime Access
          </span>
        </div>
      </div>
    </header>;
};